// extracted by mini-css-extract-plugin
module.exports = {"label":"CodeSentEmail_label__1uIZY"};